import React from 'react';
import { EnterOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { Dropdown, Input as InputArea } from 'antd';
import { Add, Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Loading from 'components/Loading';
import { get } from 'lodash';
import styled from 'styled-components';

const NonSpanishVocabTab = ({
  vocabularyData,
  showWordLoader,
  callVocAI,
  handleAddVocData,
  editDataProperty,
  handleUpdateData,
  addNewItem,
  setDeleteModal,
  setDeleteVocab,
  setSelectedMode,
  from={},
}) => {
    const dispalayRole = (value) => {
    switch (value) {
      case 'owe_admin':
        return 'Admin';
      default:
        return value;
    }
  };
  return (
    <StyledTable border className="vocabulTable">
      <StyledHeader className="vocabulHeadTh">
        <StyledTh style={{ minWidth: 150, maxWidth: 250 }}>Word</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Translation</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Definition</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Synonyms in Spanish</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Synonyms in English</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Antonyms in Spanish</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Antonyms in English</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Sentence in Spanish</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Sentence in English</StyledTh>
        <StyledTh>Actions</StyledTh>
      </StyledHeader>

      {vocabularyData.map((value, k) => {
        let data = get(value, 'data', '');
          const roleDisplay =
          from?.from === 'admin' && from?.page === 'edit-resource'
            ? `(${dispalayRole(value?.created_by)})`
            : from?.from === 'admin' && from?.page === 'inapporiate-word'
              ? `(Admin)`
              : ``;
        return (
          <tr className="vocabulHeadTr vocIcons" key={k}>
            <td style={{ minWidth: 150, maxWidth: 250 }}>
              {value?.isEditable == true ? (
                <div style={{ position: 'relative' }}>
                  <InputArea
                    onPressEnter={() => {
                      if (!showWordLoader) {
                        callVocAI();
                      }
                    }}
                    onChange={(d) => {
                      handleAddVocData('word', d.target.value.trimStart());
                    }}
                    placeholder="word"
                    autoSize
                    style={{
                      backgroundColor: 'transparent',
                      borderColor: 'transparent',
                      color: 'white',
                      fontWeight: 200,
                    }}
                  />
                  <div style={{ position: 'absolute', top: 6, right: 4 }}>
                    {showWordLoader ? (
                      <Loading size={17} />
                    ) : (
                      <EnterOutlined
                        disabled={showWordLoader}
                        onClick={() => {
                          if (!showWordLoader) {
                            callVocAI();
                          }
                        }}
                        style={{ fontSize: '25px' }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <InputArea
                    value={get(data, 'word', '') +`${roleDisplay}`}
                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'word')}
                    placeholder="word"
                    autoSize
                    style={{
                      width: 150,
                      backgroundColor: 'transparent',
                      borderColor: 'transparent',
                      color: 'white',
                      fontWeight: 200,
                    }}
                  />
                </>
              )}
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'english_translation', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'english_translation')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'definition', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'definition')
                }
                autoSize
                style={{
                  width: 200,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                  marginRight: 5,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'synonyms_in_spanish', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'synonyms_in_spanish')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'synonyms_in_english', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'synonyms_in_english')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'antonyms_in_spanish', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'antonyms_in_spanish')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'antonyms_in_english', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'antonyms_in_english')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'sentence_in_spanish', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'sentence_in_spanish')
                }
                autoSize
                style={{
                  width: 200,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'sentence_in_english', '')}
                onChange={(d) =>
                  editDataProperty(value.id, d.target.value.trimStart(), 'sentence_in_english')
                }
                autoSize
                style={{
                  width: 200,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>

            <td style={{ textAlign: 'center' }}>
              {data?.word && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Delete
                    style={{ fontSize: '20px' }}
                    onClick={() => {
                      setDeleteModal(true);
                      setDeleteVocab(value);
                    }}
                  />
                </div>
              )}
            </td>
          </tr>
        );
      })}

      <tr className="vocabulHeadTr">
        <td>
          <AddWord
            addNewItem={(key) => {
              setSelectedMode(key);
              addNewItem();
            }}
          />
          <IconButton></IconButton>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </StyledTable>
  );
};

const AddWord = ({ addNewItem, disabled }) => {
  const menu = {
    items: [
      {
        key: 'english_to_spanish',
        label: 'English to Spanish',
        className: 'custom-menu-item-1',
      },
      {
        key: 'spanish_to_english',
        label: 'Spanish to English',
        className: 'custom-menu-item-2',
      }
    ],
    onClick: (e) => addNewItem(e.key),
  };

  return (
    <Dropdown
      menu={menu}
      trigger={['click']}
      placement="bottomLeft"
      disabled={disabled}
      overlayClassName="custom-dropdown-menu"
    >
      <IconButton aria-label="add">
        <Add style={{ fontSize: '18px' }} />
      </IconButton>
    </Dropdown>
  );
};

export default NonSpanishVocabTab;

const CrossPrint = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
  width: 70px;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 95vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;

const ActionText = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
`;

const StyledTable = styled.table`
  width: 100%;
  overflow-y: auto;
  max-height: 550px;
  border-collapse: collapse;
  td {
    border: 0.5px solid #fff;
  }
  th {
    border: 0.5px solid #fff;
  }
`;

const StyledHeader = styled.tr`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
`;

const StyledTh = styled.th`
  background: #5d4187;
  color: #ffffff;
`;
